import classes from './PollingIndicator.module.scss'
import { Color, Icons, Paragraph } from '../..'
import { HiOutlineRefresh } from 'react-icons/hi'

export interface Props {
  isPolling?: boolean
  hasLabel?: boolean
}

const PollingIndicator = ({
  isPolling = true,
  hasLabel = true
}: Props) =>
  <div className={classes.PollingIndicator}>
    {
      isPolling
        ? (
          <>
            <Icons.RefreshEnabled />
            {
              hasLabel &&
                <Paragraph>
                  Auto-refresh enabled
                </Paragraph>
            }
          </>
        )
        : (
          <>
            <Color variant='lightGray'>
              <HiOutlineRefresh
                aria-hidden
                size={16}
              />
            </Color>
            {
              hasLabel &&
                <Paragraph>
                  Auto-refresh disabled
                </Paragraph>
            }
          </>
        )
    }
  </div>

export default PollingIndicator
